// extracted by mini-css-extract-plugin
export default {"body":"Companies_body__YBs80","title":"Companies_title__UPHZI","list":"Companies_list__BACya","list__item":"Companies_list__item__3Qm41"};